import React from "react";
import { GiantPill } from "../GiantPill/GiantPill";
import { StaticImageData } from "next/legacy/image";

const NFTPill: React.FC<{
  video?: string;
  image?: StaticImageData;
  title: string;
  limit?: number;
  discount?: {
    oldPrice?: string | number;
    percentText?: string;
    percentMessage?: string | React.ReactNode;
  };
  price: {
    label?: string | number;
    hideEth?: boolean;
    hideTransactionFee?: boolean;
  };
}> = ({ video, title, price, discount, limit = 1, image }) => {
  return (
    <GiantPill
      className="tab:max-w-[800px] text-left min-h-[160px]"
      videoSrc={video}
      image={image}>
      <>
        <h3 className="subhead2">{title}</h3>

        <p className="text-coinage-body body2">Limit {limit} per person</p>

        <p className="flex subhead1 gap-2 uppercase">
          {discount?.oldPrice && (
            <span className="text-coinage-gray line-through mr-2 font-thin">
              {discount.oldPrice}
            </span>
          )}
          {price.label}{" "}
          <span
            className={`caption text-coinage-body mt-2 ${
              price.hideEth && "hidden"
            }`}>
            ETH
          </span>
        </p>
        <p
          className={`caption text-coinage-body text-left ${
            price.hideTransactionFee && "hidden"
          }`}>
          + Transaction Fee
        </p>
        {discount && (
          <span
            className={`caption  rounded-2xl w-fit px-4 my-[15px] bg-coinage-orange text-white py-1`}>
            <span className="font-bold ">{discount.percentText}</span>{" "}
            {discount.percentMessage ?? ""}
          </span>
        )}
      </>
    </GiantPill>
  );
};

export default NFTPill;
